"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Restore = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _hooks = require("../../hooks");
var _Dialog = require("../Dialog");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Restore = ({
  onClose,
  onContinue,
  onReset,
  show = false
}) => {
  const [open, setOpen] = (0, _react.useState)(show);
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const handleOnClose = (0, _react.useCallback)(() => {
    setOpen(false);
    onClose();
  }, [onClose]);
  (0, _react.useEffect)(() => {
    setOpen(show);
  }, [show]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog.Dialog, {
    header: translations.Recommendation,
    open: open,
    onClose: handleOnClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      display: "flex",
      flexDirection: _styles.boxFlexDirection,
      gap: 4,
      mx: 8,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        color: "default",
        variant: "outlined",
        size: "medium",
        onClick: onReset,
        children: translations.GetNewRecommendation
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        color: "primary",
        variant: "contained",
        size: "medium",
        onClick: onContinue,
        children: translations.SeeRecommendedProduct
      })]
    })
  });
};
exports.Restore = Restore;